// typescript
import {getUriForUserOwnedImage, THUMBNAIL_IMAGE_SIZE, type ImageSizeLike} from "@/main/util/ImageUrlHelper";


export function createImageUrl(publicId: string, size: ImageSizeLike = THUMBNAIL_IMAGE_SIZE) {
    return getUriForUserOwnedImage({imagePublicId: publicId}, size);
}
